export const setPickerSide = (picker: any, pickerSide: "" | "left" | "right") => {
    if (pickerSide === "right" && picker.opened) {
        const positionClass = (picker.positionClass || "") as string;

        if (positionClass.includes("vdpPositionLeft")) {
            picker.positionClass = (picker.positionClass as string | undefined)?.replace("vdpPositionLeft", "vdpPositionRight")
        }
        else {
            picker.positionClass += " vdpPositionRight"
        }
    }
}